import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type CreateJobRequestBody = ApiRequestBody<typeof endpoints.jobs, 'post'>;

export const useCreateJobMutation = () => {
  return useMutation({
    mutationFn: async (body: CreateJobRequestBody) => {
      const { data } = await fetchClient.POST(endpoints.jobs, { body });
      return data;
    },
    onSettled: () => {
      invalidateQuery(jobsQueryKeys.lists())();
    },
  });
};
